var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurguer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 18C21.828 18 22.5 18.672 22.5 19.5C22.5 20.328 21.828 21 21 21H3C2.172 21 1.5 20.328 1.5 19.5C1.5 18.672 2.172 18 3 18H21ZM21 10.5C21.828 10.5 22.5 11.172 22.5 12C22.5 12.828 21.828 13.5 21 13.5H3C2.172 13.5 1.5 12.828 1.5 12C1.5 11.172 2.172 10.5 3 10.5H21ZM21 3C21.828 3 22.5 3.672 22.5 4.5C22.5 5.328 21.828 6 21 6H3C2.172 6 1.5 5.328 1.5 4.5C1.5 3.672 2.172 3 3 3H21Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurguer);
export default __webpack_public_path__ + "static/media/burguer.df332abc71017c6bc1f508a17d1706f1.svg";
export { ForwardRef as ReactComponent };